var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDoubleArrowLeft(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 15,
    viewBox: "0 0 12 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9062 13.875C11.0625 14.0312 11.2812 14.0312 11.4375 13.875L11.6562 13.6562C11.8125 13.5 11.8125 13.2812 11.6562 13.125L5.5625 7L11.6562 0.90625C11.8125 0.75 11.8125 0.53125 11.6562 0.375L11.4375 0.15625C11.2812 0 11.0625 0 10.9062 0.15625L4.3125 6.75C4.15625 6.90625 4.15625 7.125 4.3125 7.28125L10.9062 13.875ZM7.4375 13.875L7.65625 13.6562C7.8125 13.5 7.8125 13.2812 7.65625 13.125L1.5625 7L7.65625 0.90625C7.8125 0.75 7.8125 0.53125 7.65625 0.375L7.4375 0.15625C7.28125 0 7.0625 0 6.90625 0.15625L0.3125 6.75C0.15625 6.90625 0.15625 7.125 0.3125 7.28125L6.90625 13.875C7.0625 14.0312 7.28125 14.0312 7.4375 13.875Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleArrowLeft);
export default __webpack_public_path__ + "static/media/DoubleArrowLeft.e2001ebb52c1882e61decded0f1a32c1.svg";
export { ForwardRef as ReactComponent };